import React from 'react';
import { connect } from 'react-redux';

import DashBoardContentModules from './components/dashboard_content_modules'
import DashBoardContentTrainees from './components/dashboard_content_trainees'
import AppComponent from './components/app_component'

import { getComplianceRatings } from '../actions/v2_tags'
import * as constants from '../constants/tags'

class TagDashboard extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      traineesComplianceRating: [],
      moduleComplianceRatings: [],
      complianceRatings: [],
      activeItem: 0,
    }

  }

  // FUNCTIONS FOR DATA MANIPULATION
  componentDidMount() {
    if(this.props.activeItem) {
      this.activateMenu(this.props.activeItem)
    }

  }

  componentWillReceiveProps(nextProps){
    this.handleV2TagsNextProps(nextProps);
  }

  handleV2TagsNextProps = (nextProps) => {
    if (this.props.v2tags.requestType === nextProps.v2tags.requestType) return
    var { complianceRatings, requestType } = nextProps.v2tags

    if (requestType === constants.GET_COMPLIANCE_RATINGS_SUCCESS) {
      if(this.state.activeItem.item === 0){
        this.setState({
          moduleComplianceRatings: complianceRatings.module_ratings,
          complianceRatings: complianceRatings.compliance_ratings
        })
      } 
      else {
        this.setState({
          traineesComplianceRating: complianceRatings
        })
      }
      this.hideLoadingMessage()
    } 
    else {
      this.showLoadingMessage()
    }
  }

  // FUNCTIONS FOR UI RENDERING
  activateMenu(item) {
    this.setState({
      activeItem: item
    })

    var params = {
      id: item.id,
      include_archived_trainees: false,
      include_archived_modules: false,
      context: 'regions',
      tag_name: this.props.tagName
    }
    
    if(item.item === 0){
      params.dashboard_type = 'training_compliances_dashboard'
    } else {
      params.dashboard_type = 'trainee_compliances_dashboard'
    }

    this.props.getComplianceRatings(params)
  }

  render() {
    return (
      <div className='dashboard'>
        {
          (this.state.activeItem.item === 0) &&
          <DashBoardContentModules
            moduleComplianceRatings={ this.state.moduleComplianceRatings }
            complianceRatings={ this.state.complianceRatings }
            loading={ this.state.loading }
          />
        }
        {
          (this.state.activeItem.item === 1) &&
          <DashBoardContentTrainees
            moduleComplianceRatings={ this.state.traineesComplianceRating }
            loading={ this.state.loading }
          />
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    v2tags: state.v2tags
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getComplianceRatings: (params) => {
      return dispatch(getComplianceRatings(params))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagDashboard);



// WEBPACK FOOTER //
// ./src/views/tag_dashboard.js